import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const RegionRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkRegionAndRedirect = async () => {
      try {
        // Skip redirect for admin routes
        if (location.pathname.startsWith('/admin')) {
          return;
        }

        // If we're already on an /in path, don't do anything
        if (location.pathname.startsWith('/in')) {
          return;
        }

        // Using ipapi.co for geolocation (free tier, no API key needed)
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        
        // If user is from India and not already on /in path
        if (data.country_code === 'IN' && !location.pathname.startsWith('/in')) {
          // Handle root path specially
          if (location.pathname === '/') {
            navigate('/in', { replace: true });
            return;
          }

          // For other paths, maintain the path structure
          navigate(`/in${location.pathname}`, { replace: true });
        }
      } catch (error) {
        console.error('Error checking region:', error);
      }
    };

    checkRegionAndRedirect();
  }, [location.pathname, navigate]);

  return null;
};

export default RegionRedirect;